import { render, staticRenderFns } from "./receipt_edit.vue?vue&type=template&id=b2d776d0&scoped=true&"
import script from "./receipt_edit.vue?vue&type=script&lang=js&"
export * from "./receipt_edit.vue?vue&type=script&lang=js&"
import style0 from "./receipt_edit.vue?vue&type=style&index=0&id=b2d776d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d776d0",
  null
  
)

export default component.exports